import $select from "./$select"

export default (vm) => {
  $select(vm).get(0).selectize.destroy()
}



// WEBPACK FOOTER //
// ./src/components/fields/select/destroy.js